const parseAmericanDate = (dateStr: string): number | null => {
  if (!dateStr?.trim()) {
    return null;
  }

  const [datePart, timePart = '00:00:00'] = dateStr.trim().split(/\s+/);
  const [month, day, year] = datePart.split('/').map(part => Number(part));

  if (!month || !day || !year) {
    return null;
  }

  const [hours = 0, minutes = 0, seconds = 0] = timePart.split(':').map(part => Number(part));

  return new Date(year, month - 1, day, hours, minutes, seconds).getTime();
};

const americanDateComparator = (dateStr1: string, dateStr2: string) => {
  if (dateStr1 === dateStr2) {
    return 0;
  }

  const time1 = parseAmericanDate(dateStr1);
  const time2 = parseAmericanDate(dateStr2);

  if (time1 === null && time2 === null) {
    return 0;
  }

  if (time1 === null) {
    return -1;
  }

  if (time2 === null) {
    return 1;
  }

  if (time1 > time2) {
    return 1;
  }

  if (time1 < time2) {
    return -1;
  }

  return 0;
};

export default americanDateComparator;
